import { Box, Button, Flex, FormControl, Input, Textarea, VStack } from '@chakra-ui/react';
import React from 'react';

const SupportContactForm = () => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [supportForm, setSupportForm] = React.useState({
    email: '',
    subject: '',
    message: '',
  });
  const subjectMaxLength = 80;
  const messageMaxLength = 500;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL; // Replace with actual support email
    const mailtoLink = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      `From: ${email}\n\n${message}`,
    )}`;

    window.location.href = mailtoLink;
  };

  const { email, subject, message } = supportForm;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setSupportForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <Box as="form" onSubmit={handleSubmit}>
      <VStack spacing={4} mt={5}>
        <FormControl isRequired>
          <Input
            type="email"
            placeholder="Your email address"
            borderRadius={'16px'}
            fontSize={'small'}
            name="email"
            value={email}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl isRequired>
          <Flex align="center" position="relative">
            <Input
              type="text"
              placeholder="Subject"
              borderRadius={'16px'}
              fontSize={'small'}
              name="subject"
              value={subject}
              onChange={handleChange}
              pr="60px"
              maxLength={subjectMaxLength}
            />
            {subject.length > 0 && (
              <Box
                position="absolute"
                right="10px"
                color={subject.length > subjectMaxLength ? 'red.500' : 'gray.500'}
                fontSize="11px"
              >
                {subject.length}/{subjectMaxLength}
              </Box>
            )}
          </Flex>
        </FormControl>

        <FormControl isRequired>
          <Textarea
            placeholder="Describe your issue (max 250 words)"
            borderRadius={'16px'}
            fontSize={'small'}
            name="message"
            value={message}
            onChange={handleChange}
            minH={162}
          />
          {message.length > 0 && (
            <Box
              position="absolute"
              bottom="8px"
              right="10px"
              color={message.length > messageMaxLength ? 'red.500' : 'gray.500'}
              bg="white"
              px="2"
              fontSize="11px"
            >
              {message.length}/{messageMaxLength}
            </Box>
          )}
        </FormControl>

        <Button
          color={'white'}
          type="submit"
          bg="linear-gradient(90deg, #004BCC 0%, #0090FE 100%)"
          //   isLoading={isSubmitting}
          width="full"
          isDisabled={!email || !subject || !message || isSubmitting}
          fontSize={'small'}
          borderRadius={'40px'}
          mt={5}
          _disabled={{
            background: 'linear-gradient(90deg, #B2B2B2 0%, #999999 100%)',
            blur: '2px',
          }}
          _hover={{
            background: 'linear-gradient(90deg, #004BCC 0%, #0090FE 100%)',
          }}
        >
          Send request
        </Button>
      </VStack>
    </Box>
  );
};

export default SupportContactForm;
